import { NSARouterMakerResult } from "namirasoft-account-react";
import { RaceTargetInferencerType, RaceTargetInputRow } from "namirasoft-inference";
import { IBaseComponentProps, NSRow } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { InferenceRouterProps } from "../InferenceRouterProps";
import InferencerTypeID from "./InferencerTypeID";

export interface RaceTargetLineProps extends IBaseComponentProps, NSARouterMakerResult, InferenceRouterProps
{
	index: number;
	deletable: boolean;
	onDelete: () => void;
	onChanged?: (value: RaceTargetInputRow | null) => void;
}

const TARGET_INFO = { link: "https://namirasoft.com/inference/console-guide/race/#field-targets" };

const TYPE_LABEL: Record<RaceTargetInferencerType, string> = {
	[RaceTargetInferencerType.MODEL]: "Model",
	[RaceTargetInferencerType.LOAD_BALANCER]: "Load Balancer",
	[RaceTargetInferencerType.FAILOVER]: "Failover",
	[RaceTargetInferencerType.RACE]: "Race",
	[RaceTargetInferencerType.ROUTER]: "Router",
	[RaceTargetInferencerType.GATEWAY]: "Gateway",
};

export default class RaceTargetLine extends Component<RaceTargetLineProps>
{
	static IS_DIRTY(value: RaceTargetInputRow | null): boolean
	{
		if (value && value.inferencer_id)
			return true;
		return false;
	}

	private InferencerTypeID_Inferencer = createRef<InferencerTypeID<RaceTargetInferencerType>>();

	constructor(props: RaceTargetLineProps)
	{
		super(props);
		this.getValue = this.getValue.bind(this);
		this.isDirty = this.isDirty.bind(this);
		this.onChanged = this.onChanged.bind(this);
	}

	getValue(checkError: boolean = false): RaceTargetInputRow | null
	{
		let inferencer = this.InferencerTypeID_Inferencer.current?.getValue(checkError) ?? { inferencer_type: RaceTargetInferencerType.MODEL, inferencer_id: "" };
		if (!inferencer.inferencer_id)
			return null;
		return { inferencer_type: inferencer.inferencer_type, inferencer_id: inferencer.inferencer_id };
	}

	setValue(value: RaceTargetInputRow)
	{
		this.InferencerTypeID_Inferencer.current?.setValue({ inferencer_type: value.inferencer_type, inferencer_id: value.inferencer_id });
	}

	isDirty(): boolean
	{
		return RaceTargetLine.IS_DIRTY(this.getValue(false));
	}

	private onChanged()
	{
		if (this.props.onChanged)
			this.props.onChanged(this.getValue(false));
	}

	override render()
	{
		return (
			<NSRow style={{ ...this.props.style }}>
				<InferencerTypeID<RaceTargetInferencerType>
					ref={this.InferencerTypeID_Inferencer}
					{...this.props}
					typeTitle="Type"
					idTitle={(type) => `${TYPE_LABEL[type]} ${this.props.index + 1}`}
					required={false}
					fill
					getEnumObject={() => RaceTargetInferencerType}
					defaultType={RaceTargetInferencerType.MODEL}
					onChanged={this.onChanged}
					info={TARGET_INFO}
					menu={{
						builtin: { delete: { enabled: this.props.deletable, onDelete: () => { this.props.onDelete(); } } },
						items: []
					}}
				/>
			</NSRow>
		);
	}
}